import { SessionStore } from '../store/SessionStore';
import { useInstance } from './useInstance';

export function useCurrentUser() {
  const session = useInstance(SessionStore);
  return session.session?.user;
}
